import request from '@/utils/request'

export function getDepts(params) {
  return request({
    url: 'admin-auth/api/dept',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: 'admin-auth/api/dept',
    method: 'post',
    data
  })
}

export function del(ids) {
  return request({
    url: 'admin-auth/api/dept',
    method: 'delete',
    data: ids
  })
}

export function edit(data) {
  return request({
    url: 'admin-auth/api/dept',
    method: 'put',
    data
  })
}

export default { add, edit, del, getDepts }
